import BaseViewController from "./base-view-controller";

class VisitUscStudyAttestationViewController extends BaseViewController {
  hashChangeHandler(event) {
    const newScreenName = event.newURL.split("#")[1];
    if (!newScreenName) {
      window.onhashchange = null;
      return;
    } else if (newScreenName !== "VisitUscStudyAttestation") {
      this.handleAttestationExit(false);
      return;
    }
  }

  handleButtonClick(name, text, action) {
    if (name === "share_and_continue_enabled") {
      const attestationText = this.appData.values.attestation_body_text;
      this.processUscTrackingEvent("Display", {
        content: attestationText?.substr(0, 200)
      });
      this.processUscTrackingEvent("Agreement", {
        response: this.appData?.values.attestation_options
      });
    }
    super.handleButtonClick(name, text, action);
  }
}
export default VisitUscStudyAttestationViewController;
